<template lang="html">
  <div class="teaser-tile-item-group">
    <TeaserTileContent
      v-if="resource"
      ref="content"
      :resource="resource"
    />
    <TeaserTileMedia
      v-if="resource"
      ref="media"
      :resource="resource"
    />
  </div>
</template>

<script>
import VueTypes from 'vue-types'
import editable from '@i22/frontend-cms-utils/mixins/editable'
import TeaserTileContent from 'beisheim/components/blocks/teaser-tile-content'
import TeaserTileMedia from 'beisheim/components/blocks/teaser-tile-media'
import checkViewport from 'beisheim/mixins/check-viewport'

export default {
  components: {
    TeaserTileContent,
    TeaserTileMedia
  },
  mixins: [checkViewport, editable],
  props: {
    lastItem: VueTypes.bool.def(false)
  },
  watch: {
    elBoundingRect () {
      if (!this.inParallaxRange) { return }
      let elDistanceTop = this.elBoundingRect.top
      if (elDistanceTop >= 800) { elDistanceTop = 800 }
      const elHeight = this.elBoundingRect.height
      const offset = (elDistanceTop - window.innerHeight / 2) + elHeight / 2
      const transformY = Math.floor(offset / 4)
      let transformYCapped = Math.floor(offset / 4)
      if (transformYCapped <= 0) { transformYCapped = 0 }

      if (this.lastItem) {
        this.$refs.content.$el.style.transform = `translate3d(0, ${transformYCapped * 0.5}px, 0)`
        this.$refs.media.$el.style.transform = `translate3d(0, ${transformY * 0.6}px, 0)`
      } else {
        this.$refs.content.$el.style.transform = `translate3d(0, ${transformYCapped * 0.5}px, 0)`
        this.$refs.media.$el.style.transform = `translate3d(0, ${transformYCapped * 1.1}px, 0)`
      }
    }
  }
}
</script>

<style lang="scss">
  @import 'beisheim/scss/grid';
  @import 'beisheim/scss/colors';
  @import 'beisheim/scss/breakpoints';
  @import 'beisheim/scss/font';

  $component: '.teaser-tile-item-group';

  #{$component} {
    position: relative;
    display: flex;
    flex-direction: column;

    @include from(4) {
      flex-direction: row;

      .teaser-tile-media {
        position: relative;
        top: #{$grid * 2};
        @media screen and (min-width: $max-width) {
          position: relative;
          top: #{($max-width / 24) * 2};
        }
      }

      &:nth-child(even) {
        flex-direction: row-reverse;

        .teaser-tile-media {
          position: relative;
          top: 0;
        }

        .teaser-tile-content {
          position: relative;
          top: #{$grid * 2};
          @media screen and (min-width: $max-width) {
            position: relative;
            top: #{($max-width / 24) * 2};
          }
        }
      }
    }

    .teaser-tile-content, .teaser-tile-media {
      transition: transform 100ms linear;
      will-change: transform;
    }
  }
</style>
